<template>
  <section class="iframe-body modal_content">
    <v-stepper id="step-top" v-model="state.step" fill-height>
      <v-stepper-header style="display:none" id="step-top">
        <v-stepper-step :complete="$store.getters.step > 1" step="1">{{
          $t('step.1')
        }}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="$store.getters.step > 2" step="2">{{
          $t('step.2')
        }}</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <div style="min-height:200px">
            <Identity ref="identity"></Identity>
          </div>
        </v-stepper-content>

        <Decrypt style="display:none" ref="decrypt"></Decrypt>

        <v-stepper-content step="2">
          <div style="min-height:200px">
            <Verify ref="verify"></Verify>
          </div>
        </v-stepper-content>
        <Sign style="display:none" ref="sign"></Sign>
      </v-stepper-items>
    </v-stepper>
  </section>
</template>

<script>
import Identity from './Identity.vue';
import Decrypt from './Decrypt.vue';
import Verify from './Verify.vue';
import Sign from './Sign.vue';

export default {
  name: 'SignProcess',
  components: {
    Identity,
    Decrypt,
    Verify,
    Sign,
  },

  created: function() {
    let self = this;
    this.$eventHub.$on('eventUpdate', function(e) {
      self.$emit('eventUpdate', e);
    });
    this.$eventHub.$on('decrypt-event', function() {
      self.$refs.decrypt.submitStep();
    });
    this.$eventHub.$on('verify-event', function() {
      self.$refs.verify.verify();
    });
    this.$eventHub.$on('sign-event', function() {
      self.$refs.sign.signDocument();
    });
  },
  computed: {},
  data() {
    return {};
  },
};
</script>

<style>
.v-stepper__content {
  padding: 0;
}

.theme--light.v-stepper .v-stepper__header .v-stepper__label {
  object-fit: contain;
  font-family: 'Montserrat';
  font-size: 13px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
}
.theme--light.v-stepper
  .v-stepper__header
  .v-stepper__step--complete
  .v-stepper__label {
  color: #01a3b0;
}

.theme--light.v-stepper
  .v-stepper__header
  .v-stepper__step--complete
  .v-stepper__step__step {
  object-fit: contain;
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
  border: solid 1px #01a3b0 !important;
  background-color: #01a3b0 !important;
}

.theme--light.v-stepper
  .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error)
  .v-stepper__step__step {
  border: solid 1px #d8d8d8;
  color: #d8d8d8;
  background: white;
  object-fit: contain;
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
}

.theme--light.v-stepper
  .v-stepper__header
  .v-stepper__step.v-stepper__step--active
  .v-stepper__step__step {
  border: solid 1px #035b60 !important;
  color: #035b60;
  background: white !important;
  object-fit: contain;
  font-family: 'Montserrat';
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
}

.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {
  color: #035b60;
  object-fit: contain;
  font-family: 'Montserrat';
  font-size: 13px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.54;
  letter-spacing: normal;
}
</style>
